export let devplus = {
    body: document.querySelector( 'body' ),
    html: document.querySelector( 'html' ),
    nav_toggler: document.querySelector( '.nav-toggler' ),
    adminbar: document.querySelector( '#wpadminbar' ),
    cookies_bar: document.querySelector( '#page-cookies' ),
    cookie_consent_given: false,
    cookie_consent_name: 'immobrown_cookie_consent',
};

// openklappen navigatie
export function nav_toggler() {

    devplus.nav_toggler.addEventListener( 'click', ( e ) => {

        e.preventDefault();
    
        devplus.body.classList.toggle( 'nav-open' );
    
    } );

}

// type scroll to link support
export function scroll_to_links() {

	const links = document.querySelectorAll( '.type-scroll-to' );

	if ( links.length ) {

		links.forEach( link => {

			link.addEventListener( 'click', function ( e ) {

				e.preventDefault();

				scroll_to_element( link.getAttribute( 'data-selector' ) );

			} );

		} );

	}

}

// scroll to support
export function scroll_to_element( element, behavior = 'smooth' ) {

	if ( typeof element === 'string' ) {

		element = document.querySelector( element );

	}

    if ( typeof element === 'undefined' ) {

        return;

    }

	if ( element ) {

		try {

			element.scrollIntoView( {
				behavior
			} );

		} catch ( e ) {

			window.scrollTo( {
				top: element.offsetTop,
				behavior
			} );

		}

	}

}

// naar estate form scrollen
export function scroll_to_estate_form() {

	const url = new URL( window.location.href );

	const params = url.searchParams;

	if ( params.has( 'ref' ) && params.has( 'action' ) ) {

		const estate_form_zone = document.querySelector( '.zone-estate-contact-form' );

		if ( estate_form_zone ) {

			// spring direct naar formulier en pand; 'auto' zou de globale CSS-smoothscroll overnemen.
			scroll_to_element( estate_form_zone, 'instant' );

		}

	}

}

// naar zone scrollen
export function scroll_to_zone_id() {

	if ( window.location.hash ) {

		const zone_id_in_hash = /^#zone-(\d+)$/.exec( window.location.hash );

		if ( zone_id_in_hash ) {

			const zone_id = parseInt( zone_id_in_hash[1], 10 );

			scroll_to_element( '.zone:nth-child(' + ( zone_id + 1 ) + ')' );

		}

	}

}

// html naar een dom element omzetten
export function html_to_element( html ) {

	const template = document.createElement( 'template' );

	template.innerHTML = html.trim();

	return template.content.firstElementChild;

};
